import React, { Component } from 'react';

class Footer extends Component {

	render() {
		const link = "text-on-surface-variant font-label-sm text-label-sm hover:text-on-surface transition-colors";
		return (
			<footer className="bg-surface-container-lowest py-12 border-t border-outline-variant mt-auto">
				<div className="w-full px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto flex flex-col md:flex-row justify-between items-center gap-gutter">
					<div className="font-headline-lg text-headline-lg font-bold text-on-surface flex items-center gap-2">
						<span className="material-symbols-outlined text-primary-container text-3xl">mic</span>
						ZERO TO N
					</div>
					<ul className="flex flex-wrap justify-center gap-6">
						<li><a className={link} href="https://open.spotify.com/show/1BeAW7hI9MSdloLx7mnQUQ?si=9d426df2fada42fb" target="_blank" rel="noopener noreferrer">Spotify</a></li>
						<li><a className={link} href="https://podcasts.apple.com/co/podcast/from-zero-to-n/id1584666207?l=en" target="_blank" rel="noopener noreferrer">Apple Podcasts</a></li>
						<li><a className={link} href="https://music.amazon.com.mx/podcasts/64044734-2289-4c63-85b2-584117c702f6/from-zero-to-n" target="_blank" rel="noopener noreferrer">Amazon Music</a></li>
					</ul>
					<div className="font-body-md text-body-md text-on-surface-variant text-sm">
						© {new Date().getFullYear()} FROM ZERO TO N. All rights reserved.
					</div>
				</div>
			</footer>
		);
	}

}
export default Footer;
